module.exports = __webpack_public_path__ + "home/en-US/images/white_drag_box-302b7f99b43fe741093823958854dc9f.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/white_drag_box.png
// module id = s2Yx
// module chunks = 0